document.addEventListener('DOMContentLoaded', function () {

  // 🔥 Overlay erstellen
  const overlay = document.createElement('div');
  overlay.id = 'ks-upsell-overlay';
  overlay.innerHTML = `
    <div class="ks-upsell-box">
      <div class="ks-upsell-header">Perfekt ergänzt</div>
      <div class="ks-upsell-items"></div>
      <div class="ks-upsell-actions">
        <button class="ks-upsell-add">Alles hinzufügen</button>
        <button class="ks-upsell-skip">Weiter ohne</button>
      </div>
    </div>
  `;
  document.body.appendChild(overlay);

  const itemsContainer = overlay.querySelector('.ks-upsell-items');
  const addBtn = overlay.querySelector('.ks-upsell-add');
  const skipBtn = overlay.querySelector('.ks-upsell-skip');

  let currentBundle = [];

  // 🔥 Event Listener (hook auf Cart Add)
  document.addEventListener('ajaxProduct:added', function (e) {

    const product = e.detail?.product;
    if (!product) return;

    let upsellHandles = [];
        const productTags = Array.isArray(product.tags) ? product.tags : [];

    if (productTags.includes('toy')) {
      upsellHandles = window.ksUpsell?.toys || [];
    } else if (productTags.includes('dessous')) {
      upsellHandles = window.ksUpsell?.lingerie || [];
    } else if (productTags.includes('bdsm')) {
      upsellHandles = window.ksUpsell?.bdsm || [];
    }

    if (!upsellHandles.length) return;

    currentBundle = [];
    itemsContainer.innerHTML = '';

    upsellHandles.forEach(handle => {
      fetch(`/products/${handle}.js`)
        .then(r => r.json())
        .then(p => {

          currentBundle.push(p.variants[0].id);

          const el = document.createElement('div');
          el.className = 'ks-upsell-item';
          el.innerHTML = `
            <img src="${p.images[0]}" />
            <span>${p.title}</span>
          `;
          itemsContainer.appendChild(el);
        });
    });

    overlay.classList.add('active');
  });

  // 🔥 Add Bundle
  addBtn.addEventListener('click', function () {

    if (!currentBundle.length) return;

    const items = currentBundle.map(id => ({
      id: id,
      quantity: 1
    }));

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    }).then(() => {
      overlay.classList.remove('active');
      document.dispatchEvent(new Event('cart:refresh'));
    });
  });

  // 🔥 Skip
  skipBtn.addEventListener('click', function () {
    overlay.classList.remove('active');
  });

});